import { store } from '../store';

export const fetchWrapper = {
    get: request('GET'),
    post: request('POST'),
    put: request('PUT'),
    patch: request('PATCH'),
    delete: request('DELETE'),
    postSend: requestSend('POST'),
    upload: uploadRequest('POST')

};

function requestSend(method) {
    return (url, body) => {
        const requestOptions = {
            method,
            headers: authHeader(url)
        };
        if (body) {
            requestOptions.headers['Content-Type'] = 'application/json';


            //requestOptions.headers['Access-Control-Allow-Origin'] = '*';

            requestOptions.body = JSON.stringify(body);
        }

        requestOptions.headers['x-access-token'] = localStorage.getItem('user');
        return fetch(url, requestOptions).then(handleResponse);
    }
}

function uploadRequest(method) {
    return (url, formData) => {
        const requestOptions = {
            method,
            headers: {
                ...authHeader(url),

                'x-access-token': localStorage.getItem('user')
            },
            body: formData
        };

        // DON'T set Content-Type manually for FormData
        return fetch(url, requestOptions).then(handleResponse);
    };
}


function request(method) {
    return (url, body) => {
        const requestOptions = {
            method,
            headers: authHeader(url)
        };
        if (body) {
            requestOptions.headers['Content-Type'] = 'application/json';

            //requestOptions.headers['Access-Control-Allow-Origin'] = '*';

            requestOptions.body = JSON.stringify(body);
        }
        requestOptions.headers['x-access-token'] = localStorage.getItem('user');
        return fetch(url, requestOptions).then(handleResponse);
    }
}

// helper functions

function authHeader(url) {
    // return auth header with jwt if user is logged in and request is to the api url
    const token = authToken();
    const isLoggedIn = !!token;
    const isApiUrl = url.startsWith(process.env.REACT_APP_API_URL);
    if (isLoggedIn && isApiUrl) {
        return { Authorization: `Bearer ${token}`, "ngrok-skip-browser-warning": "69420" };
    } else {
        return {};
    }
}

function authToken() {
    return store.getState().auth.user?.token;
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if ([401, 403].includes(response.status)) {

            localStorage.clear();
            window.location.href = '/';
        }
        if (!response.ok) {
           return response
        }


        return data;
    });
}